import { defineMessages } from 'react-intl';

const messages = defineMessages({
  walletDescription: {
    description: 'Setup Wallet description',
    defaultMessage: 'Manage carriers, postage and insurance from a shared balance with discounted rates. <link>Get started</link>',
    id: 'kvUwr6',
  },
  sectionSubheader: {
    description: 'Wallet section subheader text',
    defaultMessage: 'Shipping services set up, managed, and paid from your balance',
    id: 'VjPzym',
  },
  setUpCarriersButton: {
    description: 'Wallet set up carriers button',
    defaultMessage: 'Set up carriers',
    id: 'UHT5OA',
  },
  balanceSection: {
    description: 'Wallet Balance section',
    defaultMessage: '<bold>Balance</bold>: {balance}',
    id: 'bqxS7h',
  },
  addFundsLink: {
    description: 'Wallet add funds button',
    defaultMessage: 'Add Funds',
    id: 'b5ai0F',
  },
  updatePayment: {
    description: 'Wallet update payment method link',
    defaultMessage: 'Update payment method',
    id: 'f7/LVA',
  },
  changeNickname: {
    description: 'Wallet change nickname link',
    defaultMessage: 'Change nickname',
    id: 'aLlJHm',
  },
  manageAutoFunding: {
    description: 'Wallet manage auto-funding link',
    defaultMessage: 'Manage auto-funding',
    id: 'Oh76XT',
  },
  save: {
    description: 'Wallet save button',
    defaultMessage: 'Save',
    id: 'rjMfXO',
  },
  cancel: {
    description: 'Wallet cancel button',
    defaultMessage: 'Cancel',
    id: 'iFpMiv',
  },
  savingError: {
    description: 'Save ShipStations specific Carriers modal save error',
    defaultMessage: 'Unexpected error saving provider settings',
    id: '2R0sIQ',
  },
  walletSettings: {
    description: 'Wallet settings tooltip',
    defaultMessage: '{walletBrandName} Settings',
    id: '5G93rn',
  },
  walletUpdatePaymentMethodSuccessContent: {
    description: 'Content for notification for successfully updating payment info',
    defaultMessage:
      'The billing information for {walletBrandName} has been updated. If you also need to update billing information for your ShipStation subscription, go to the <link>Payment & Subscription Page</link>.',
    id: '4V5J2o',
  },
  walletUpdatePaymentMethodSuccessContentLegacy: {
    description: 'Content for notification for successfully updating payment info',
    defaultMessage:
      'The billing information for {walletBrandName} has been updated. If you also need to update billing information for your ShipStation subscription, go to the <link>Subscription Page</link>.',
    id: '9N2PSg',
  },
  viewReports: {
    description: 'Wallet settings dropdown option - View reports',
    defaultMessage: 'View reports',
    id: 'Z2jgeD',
  },
  refreshServices: {
    description: 'Wallet provider settings dropdown option - Refresh services',
    defaultMessage: 'Refresh services',
    id: 'm7Cgei',
  },
  refreshServiceSuccess: {
    description: 'Success message after refreshing servie',
    defaultMessage: 'Services have been refreshed!',
    id: 'K7vpcI',
  },
  refreshServiceError: {
    description: 'Error message after refreshing servie',
    defaultMessage: 'Failed to refresh services. Please try again.',
    id: 'BSUpgO',
  },
  openSettings: {
    description: 'Wallet provider settings dropdown option - Account settings',
    defaultMessage: 'Account settings',
    id: 'vtQMp5',
  },
  preferAccount: {
    description: 'Wallet provider settings dropdown option - Prefer this account',
    defaultMessage: 'Prefer this account',
    id: 'RZYKk9',
  },
  reauthorize: {
    description: 'Wallet provider settings dropdown option - Reauthorize',
    defaultMessage: 'Reauthorize',
    id: 'lc5DKN',
  },
  newPasswordLabel: {
    description: 'New password input field label',
    defaultMessage: 'New Password',
    id: '0ZQOQV',
  },
  confirmPasswordLabel: {
    description: 'Re-enter new password input field label',
    defaultMessage: 'Re-enter New Password',
    id: 'w0p6A0',
  },
  passwordsDoNotMatch: {
    description: 'Error message when both password fields do not match',
    defaultMessage: 'Please enter the same password.',
    id: 'baoixu',
  },
  updatePasswordError: {
    description: 'Generic message when updating password fails',
    defaultMessage: 'Failed to update password. Please try again.',
    id: 'I3kLuW',
  },
  updatePasswordDescription: {
    description: 'Description for update password modal',
    defaultMessage:
      'If you have updated your Stamps account password on the Stamps.com website, enter your updated password below to maintain the connection to ShipStation.',
    id: 'PN8ijd',
  },
  updatePasswordLockoutWarning: {
    description: 'Warning message for update password modal',
    defaultMessage:
      'If you did not connect your own Stamps.com account to ShipStation, you will not have a Stamps.com account password to change and will not need to reauthorize. For any issues creating labels, please contact ShipStation Support.',
    id: 'mBFUGK',
  },
  walletUpdatePaymentMethodSuccessHeader: {
    description: 'Header for notification for successfully updating payment info',
    defaultMessage: 'Success',
    id: '9gc6nJ',
  },
  tableHeaderCarrier: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Carrier',
    id: '/BzFkX',
  },
  insurance: {
    description: 'Table cell text for Insurance row',
    defaultMessage: 'Insurance',
    id: 'p7Ka0r',
  },
  tableHeaderPreferredAccount: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Preferred Account',
    id: 'g+3Shb',
  },
  tableHeaderServices: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Services',
    id: 'FVQkY7',
  },
  tableHeaderActions: {
    description: 'Table header for Wallet table',
    defaultMessage: 'Actions',
    id: 'ByhX9e',
  },
  missingProviderFallbackMessage: {
    description: 'Fallback message if provider information is missing',
    defaultMessage: 'Unknown Provider',
    id: 'wpRV3W',
  },
  viewBalanceHistory: {
    description: 'message for link to view balance history',
    defaultMessage: 'View Balance History',
    id: 'u0C21x',
  },
  featuresHeader: {
    description: 'Header for features modal',
    defaultMessage: 'Features & Benefits',
    id: '+mPC96',
  },
  featuresModalCarrier: {
    description: 'Specifies the carrier for features modal',
    defaultMessage: '{carrierName} from ShipStation',
    id: 'nwuiOH',
  },
});

export default messages;
